import React, { useId } from 'react';
import SecretInput from './ui/SecretInput';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  required?: boolean;
  id?: string;
};

export default function PasswordFieldWithToggle({
  label,
  value,
  onChange,
  autoComplete,
  required,
  id: idProp,
}: Props) {
  const autoId = useId();
  const id = idProp ?? autoId;

  return (
    <div className="form-field password-field">
      <label htmlFor={id}>{label}</label>
      <SecretInput
        id={id}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
      />
    </div>
  );
}
